

export default {
  name: 'AuthorizedCheckMark',
  components: { },
  props: {
    isAuthorized: {
      type: Boolean,
      default: false,
    },
    fromTopLeft: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
}
